export default "__VITE_PUBLIC_ASSET__2ee4059f__"